const roles = {
    OIDC_ROLES: {
        GST_ADMIN: 'GST Admin',
        GST_CUSTOMER_SUPPORT: 'GST Customer Support',
        GST_FINANCE_USER: 'GST Finance User',
        CUSTOMER_SUPPORT_MANAGER: 'Customer Support Manager',
        CUSTOMER_SUPPORT: 'Customer Support',
        CUSTOMER_VIEWER: 'Customer Viewer',
        CUSTOMER_REPORTS: 'Customer Reports',
        SALES_REPORTS: 'Sales Reports',
        PRODUCT_VIEWER: 'Product Viewer',
        FINANCE_REPORTS: 'Finance Reports',
        PRODUCT_MANAGER: 'Product Manager',
    },
};

export default roles;
